import { createContext } from 'react';
export const GeocodingContext = createContext({
    geocodingCountries: [],
});
